// types
export const SET_RECEIPT = 'SET_RECEIPT'

// actions
export const setReceipt = ({ receipts }) => ({
  type: SET_RECEIPT,
  receipts,
})
